import request from "@/utils/request.js";
const baseURL = '/publicity'
const proxy = '/deposit'

const api = {
    // 首页物业区域
    listWyqy: (params) => {
        return request({
            url: baseURL + "/gzh/listWyqy",
            method: "get",
            params,
        });
    },
    //资金列表查询
    zjQuery: (params) => {
        return request({
            url: baseURL + "/gzh/zjQuery",
            method: "get",
            params,
        });
    },
    // 资金详情查询
    fundDetails: (fhid) => {
        return request({
            url: baseURL + `/gzh/fundDetails/${fhid}`,
            method: "get",
        });
    },
    // 详细信息 

    getDetailed: (data) => {
        return request({
            url: baseURL + `/gzh/getDetailed`,
            method: "post",
            data
        });
    },
    // 资金交存
    getJcTzd: (params) => {
        return request({
            url: baseURL + `/gzh/getJcTzd`,
            method: "get",
            params
        });
    },

    // 交存详情

    tzdH5: (params) => {
        return request({
            url: proxy + `/api/wxzjjctzd/tzdH5`,
            method: "get",
            params
        });
    },
}
export default api
